import { ProductTypeKey } from 'shared/types/product/Product';

// Env-overridable so a staging site can point PDPs at a staging builder without a code change,
// mirroring `customQuoteLink` (product-list/context/constants.ts) and `RAILING_BUILDER_URL`
// (helpers/railingBuilder.ts).
const GLASS_BUILDER_URL = process.env.NEXT_PUBLIC_GLASS_BUILDER_URL || 'https://glass.viewrail.com/';

// Every product on this product type is a glass panel system the builder produces (3 products,
// confirmed against commercetools — nothing else carries this type), so the callout belongs on
// all of them and nowhere else.
const GLASS_BUILDER_PRODUCT_TYPES: ProductTypeKey[] = ['glass-panel'];

/**
 * Resolves the Glass Designer builder URL for a glass-panel PDP, or `null` when the product's type
 * isn't one the builder produces (so the callout simply hides — a safe default).
 */
export const getGlassBuilderUrl = (productType: ProductTypeKey | undefined): string | null =>
  productType && GLASS_BUILDER_PRODUCT_TYPES.includes(productType) ? GLASS_BUILDER_URL : null;
